import React from 'react'
import Stack from '@mui/material/Stack'
import { useFormContext, useWatch } from 'react-hook-form'
import type { StackProps } from '@mui/material/Stack'
import TextField from '../TextField'
import SelectField from '../SelectField'
import StartLabelField from './StartLabelField'
import type { SelectFieldProps } from '../SelectField'
import type { TextFieldProps } from '../TextField'

type Props = {
    label: string
    selectProps: SelectFieldProps
    textFieldProps: TextFieldProps
} & StackProps

/**
 *  Must be in the grid container to display properly
 * */
export const StartLabelFilterStack: React.VFC<Props> = ({
    label,
    selectProps,
    textFieldProps,
    ...stackProps
}: Props) => {
    const { getValues, setValue } = useFormContext()
    const selectedValue = useWatch({ name: selectProps.name }) as string
    const showTextField = !!selectedValue

    React.useEffect(() => {
        if (!showTextField) {
            const priorValue = getValues(textFieldProps.name) as string
            if (priorValue) {
                setValue(textFieldProps.name, undefined)
            }
        }
    }, [setValue, showTextField, textFieldProps.name])

    return (
        <StartLabelField label={label} name={selectProps.name}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} {...stackProps}>
                <SelectField {...selectProps} />
                {showTextField && <TextField {...textFieldProps} />}
            </Stack>
        </StartLabelField>
    )
}

export default StartLabelFilterStack
export type { Props as StartLabelFilterStackProps }
